module.exports = __webpack_public_path__ + "../resources/img/ic-redo.8229c1eb.svg";